// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__MD5xC _layout_layout-grid__SMCSl"};